<template>
  <div class="timeline">
    <div class="year" v-for="(months, year, index) in visibleChapters" :class="{'active': year === currentYear}" :key="index">
      <div class="year-row" :class="{'active': year === currentYear}">
        <span class="tl-action-btn hide-btn" v-if="editable && hasVisibleMonths(year)" @click.stop="$emit('hideYear', year)">Hide</span>
        <div class="year-label" :class="{'active': year === currentYear}" @click="toggleYear(year)">
          {{year}}{{$t('preview.yearSuffix')}}
        </div>
      </div>
      <ul class="months" :class="{'active': year === currentYear}">
        <li v-for="month in visibleMonthsOf(year)" :key="month.month"
            :class="{'active': month.time === currentTime}">
          <span class="tl-action-btn hide-btn" v-if="editable" @click.stop="$emit('hideMonth', month)">Hide</span>
          <a href="javascript:;" @click="changeChapterMonth(month)">
            {{month.month}}{{$t('preview.monthSuffix')}}
          </a>
        </li>
      </ul>
    </div>
    <!-- 永久"Add More"入口（仅编辑模式，跟在最后一年后） -->
    <div class="year" v-if="editable">
      <div class="year-row">
        <span class="tl-action-btn"></span>
        <div class="year-label" @click="$emit('addContent')">
          {{$t('selection.buttonPatch')}}
        </div>
      </div>
    </div>
    <!-- Hidden months section (only in edit mode) -->
    <div class="hidden-section" v-if="editable && hiddenMonths.length">
      <div class="hidden-title" @click="hiddenExpanded = !hiddenExpanded">
        <i class="fa fa-eye-slash"></i>
        {{$t('editor.hiddenMonths')}}
        <i :class="['fa', hiddenExpanded ? 'fa-angle-up' : 'fa-angle-down']"></i>
      </div>
      <div class="year hidden-year" v-show="hiddenExpanded" v-for="(months, year) in hiddenByYear" :key="'h-'+year"
           :class="{'active': hiddenExpandedYear === year}">
        <div class="year-row">
          <span class="tl-action-btn show-btn" @click.stop="showAllInYear(year)">Show</span>
          <div class="year-label" :class="{'active': hiddenExpandedYear === year}"
               @click="hiddenExpandedYear = hiddenExpandedYear === year ? '' : year">
            {{year}}{{$t('preview.yearSuffix')}}
          </div>
        </div>
        <ul class="months" :class="{'active': hiddenExpandedYear === year}">
          <li v-for="month in months" :key="month.time">
            <span class="tl-action-btn show-btn" @click.stop="$emit('showMonth', month)">Show</span>
            <a href="javascript:;" @click="$emit('showMonth', month)">
              {{month.month}}{{$t('preview.monthSuffix')}}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndex } from 'lodash'
export default {
  name: 'content-timeline',
  props: {
    chapters: {
      type: Object,
      default: function () { return {} }
    },
    activeYear: { type: String, default: '' },
    activeMonth: { type: String, default: '' },
    clearSelection: { type: Boolean, default: false },
    editable: { type: Boolean, default: false }
  },
  data () {
    return {
      currentYear: '',
      currentTime: '',
      hiddenExpandedYear: '',
      hiddenExpanded: true
    }
  },
  computed: {
    visibleChapters () {
      const result = {}
      Object.keys(this.chapters).forEach(year => {
        const visible = this.chapters[year].filter(m => !m.deleted)
        if (visible.length) result[year] = this.chapters[year]
      })
      return result
    },
    hiddenMonths () {
      const result = []
      Object.keys(this.chapters).forEach(year => {
        this.chapters[year].forEach(month => {
          if (month.deleted) {
            month._year = year
            result.push(month)
          }
        })
      })
      return result
    },
    hiddenByYear () {
      const groups = {}
      this.hiddenMonths.forEach(m => {
        groups[m._year] = groups[m._year] || []
        groups[m._year].push(m)
      })
      return groups
    }
  },
  watch: {
    clearSelection (val) {
      if (val) {
        this.currentYear = ''
        this.currentTime = ''
      } else {
        if (this.activeYear) this.currentYear = this.activeYear
        if (this.activeYear && this.activeMonth) this.currentTime = this.activeYear + this.activeMonth
      }
    },
    activeYear (val) {
      if (!this.clearSelection && val) this.currentYear = val
    },
    activeMonth (val) {
      if (!this.clearSelection && val && this.activeYear) this.currentTime = this.activeYear + val
    }
  },
  created () {
    if (!this.clearSelection) {
      this.currentYear = this.activeYear
      this.currentTime = this.activeYear + this.activeMonth
    }
  },
  methods: {
    yearStatus (year) {
      let status = true
      this.chapters[year].map(item => { status = status && item.deleted })
      return status
    },
    hasVisibleMonths (year) {
      return this.chapters[year].some(m => !m.deleted)
    },
    visibleMonthsOf (year) {
      return this.chapters[year].filter(m => !m.deleted)
    },
    toggleYear (year) {
      this.currentYear = this.currentYear === year ? '' : year
    },
    changeChapterMonth (month) {
      this.currentTime = month.time
      this.$emit('changeMonth', month)
    },
    saveChapters (time) {
      const year = time.substr(0, 4)
      const chapter = findIndex(this.chapters[year], { time })
      this.chapters[year][chapter].deleted = !this.chapters[year][chapter].deleted
    },
    showAllInYear (year) {
      this.$emit('showYear', year)
    }
  }
}
</script>

<style lang="scss">
.timeline {
  display: inline-block;
  $darkGray: #e9e9e9;

  .year {
    overflow: hidden;
    padding-bottom: .5rem;
    position: relative;
    &.active:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 2px;
      height: 100%;
      background-color: $darkGray;
    }
  }

  // Year row: action btn + year label
  .year-row {
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover .tl-action-btn { opacity: 1; }
  }

  .year-label {
    flex: 1;
    position: relative;
    z-index: 3;
    padding: .5rem .8rem;
    background: $darkGray;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    font-weight: 600;
    transition: .35s;
    text-align: right;
    &:hover {
      background: lighten($el-color-primary, 10%);
      color: white;
    }
    &.active {
      background: $el-color-primary;
      color: white;
    }
  }

  // Shared action button style — fixed width for alignment
  .tl-action-btn {
    font-size: 10px;
    font-weight: 500;
    opacity: 0;
    cursor: pointer;
    padding: 2px 0;
    border-radius: 3px;
    white-space: nowrap;
    transition: opacity 0.2s, color 0.15s;
    flex-shrink: 0;
    width: 30px;
    text-align: center;

    &.hide-btn {
      color: #999;
      &:hover { color: #666; }
    }
    &.show-btn {
      color: $el-color-primary;
      &:hover { color: darken($el-color-primary, 10%); }
    }
  }

  .months {
    overflow: hidden;
    max-height: 0;
    transition: .5s;
    text-align: right;
    &.active { max-height: 27em; }
    li {
      position: relative;
      z-index: 2;
      transition: .25s;
      border-right: 2px solid $darkGray;
      display: flex;
      align-items: center;
      &.active {
        color: $el-color-primary;
        border-right: 2px solid $el-color-primary;
        a { color: $el-color-primary; }
      }
      &:hover .tl-action-btn { opacity: 1; }
      a {
        flex: 1;
        line-height: 1.56rem;
        height: 1.56rem;
        display: block;
        padding-right: 14px;
        font-size: 14px;
        text-align: right;
      }
    }
  }

  .hidden-section {
    margin-top: 1rem;
    padding-top: 0.75rem;
    border-top: 1px dashed #ddd;

    .hidden-year .year-label {
      background: #d5d5d5;
      color: #777;
      &:hover { background: #ccc; color: #555; }
      &.active { background: #bbb; color: #444; }
    }
    .hidden-year .months li a {
      color: #999;
    }
  }
  .hidden-title {
    font-size: 12px;
    color: #999;
    text-align: right;
    padding-right: 14px;
    margin-bottom: 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
    &:hover { color: #666; }
    .fa { font-size: 12px; }
  }
}

// Mobile: inside toc panels, right-align everything, hide action buttons
.ce-mobile-toc__panel .timeline,
.previewer__m-toc-panel .timeline {
  display: block;
  text-align: right;

  .tl-action-btn { display: none !important; }
  .year-row { justify-content: flex-end; }
  .year-label { flex: none; width: 80px; text-align: center; box-sizing: border-box; }
  .months { text-align: right; }
  .months li { justify-content: flex-end; }
  .months li a { flex: none; text-align: right; }
  .hidden-section { display: none; }
}
</style>
